import type { SxProps, Theme } from "@mui/material/styles";

export const breadcrumbRootSx: SxProps<Theme> = {
  marginTop: 0,
  marginLeft: 0,
  width: "auto",
  position: "static",
  boxShadow: "none",
  backgroundColor: "transparent",
  zIndex: "auto",
  px: { xs: 2, md: 4 },
  pt: 1.5,
  pb: 0.5,
};

export const breadcrumbTrailSx: SxProps<Theme> = {
  color: "text.secondary",
  marginLeft: 0,
};
